import { TFunction } from 'i18next'
import { z } from 'zod'

import { UserRole, UserRoleEnum } from '@/models/features/user.models'

// Note: building 805 has Salto Space enabled without the saltoSpaceAvailable flag set on the building
// TODO: remove once building 805 has saltoSpaceAvailable corrected in the database
export const SALTO_SPACE_ALWAYS_AVAILABLE_BUILDING_IDS = [805]

export const KeylessTabKeyEnum = z.enum([
  'dormakaba',
  'remote-lock',
  'salto-space',
  'swiftlane',
  'seam-visionline',
  'point-central',
  'igloo',
])

export type KeylessTabKey = z.infer<typeof KeylessTabKeyEnum>

export const KEYLESS_TAB = {
  DORMAKABA: KeylessTabKeyEnum.enum.dormakaba,
  IGLOO: KeylessTabKeyEnum.enum.igloo,
  POINT_CENTRAL: KeylessTabKeyEnum.enum['point-central'],
  REMOTE_LOCK: KeylessTabKeyEnum.enum['remote-lock'],
  SALTO_SPACE: KeylessTabKeyEnum.enum['salto-space'],
  SEAM_VISIONLINE: KeylessTabKeyEnum.enum['seam-visionline'],
  SWIFTLANE: KeylessTabKeyEnum.enum.swiftlane,
} as const satisfies Record<string, KeylessTabKey>

export const getKeylessTabLabels = (t: TFunction<['clients']>): Record<KeylessTabKey, string> => ({
  dormakaba: t('clients:keylessAccess.tabLabels.dormakaba'),
  igloo: t('clients:keylessAccess.tabLabels.igloo'),
  'point-central': t('clients:keylessAccess.tabLabels.pointCentral'),
  'remote-lock': t('clients:keylessAccess.tabLabels.remoteLock'),
  'salto-space': t('clients:keylessAccess.tabLabels.saltoSpace'),
  'seam-visionline': t('clients:keylessAccess.tabLabels.seamVisionline'),
  swiftlane: t('clients:keylessAccess.tabLabels.swiftlane'),
})

const KEYLESS_EDIT_ALLOWED_ROLES: UserRole[] = [
  UserRoleEnum.enum.Administrator,
  UserRoleEnum.enum.PropertyManager,
  UserRoleEnum.enum.Manager,
  UserRoleEnum.enum.ShiftManager,
]

export const canEditKeylessAccess = (userRole: string | null): boolean =>
  !!userRole && (KEYLESS_EDIT_ALLOWED_ROLES as string[]).includes(userRole)
